import React from 'react'
import {connect} from 'react-redux'
import {
    fetchRenameCol,
    resetCreatedCol
} from 'modules/entities/actions'
import {
    fetchDocumentUpdate,
    resetCreatedRow,
    fetchReorderColumns,
    fetchResizeColumn,
    selectionChange
} from 'modules/collection/actions'
import {fieldtype} from 'utils/enums/fieldtype'
import TableCell from 'components/TableCell'
import HeaderCell from 'components/HeaderCell'
import Feedback from 'components/Feedback'
// import Table from './Table'
import {Table} from '@framelink/spreadsheet_ts'
import Empty from './Empty'

class Spreadsheet extends React.Component {
    componentDidUpdate(props) {
        if (this.props.createdRow) {
            const index = this.props.documents.findIndex(item => item.id === this.props.createdRow)

            if (index !== -1) {
                const container = document.getElementById('spreadsheet')
                container.scrollTo(0, index * global.TABLE_ROW_HEIGHT)
                
                setTimeout(() => {
                const elem = document.querySelector(`[data-row='${this.props.createdRow}'] > * `)

                if (elem) {
                    elem.focus()
                    this.props.resetCreatedRow()
                }}, 300)
            }
        }

        if (this.props.createdCol && this.props.createdCol !== props.createdCol) {
            const container = document.getElementById('spreadsheet')
            const width = container.scrollWidth
            container.scrollTo(width, 0)

            setTimeout(() => {
                document.querySelector(`[data-id='${this.props.createdCol}'] > input `).select()
                this.props.resetCreatedCol()
            }, 300)
        }

        if (props.view !== this.props.view) {
            const cells = document.querySelectorAll('[data-id]')
            cells.forEach((item, index) => {
                cells[index].style.width = ''
            })
        }
    }

    getValue = (col, row) => {
        return col.type === fieldtype.linkedfield || col.type === fieldtype.lookup || col.type === fieldtype.formula ?
            row['d' + col.name] : row['c' + col.name]
                
    }

    renderCell = (value, col, row) => {
        return <TableCell
            row={row}
            column={col}
            value={value}
            onUpdate={this.props.fetchDocumentUpdate}
        />
    }

    renderHeaderCell = (data) => {
        return <HeaderCell
            data={data}
            editableHeader={this.props.permissions.Designer && !this.props.mobile}
            handleBlur={this.props.fetchRenameCol}
            handleFocus={this.props.handleSelectCol}
        />
    }

    renderFixedCell = (data) => {
        return <Feedback feedback={data.feedback} />
    }

    render() {
        return (
            <Table
                totals={this.props.totals}
                onResizeEnd={this.props.fetchResizeColumn}
                onDragEnd={this.props.fetchReorderColumns}
                onHeaderBlur={this.props.fetchRenameCol}
                onValueChange={this.props.fetchDocumentUpdate}
                onSelect={this.props.selectionChange}
                rows={this.props.documents}
                columns={this.props.columns}
                onHeaderFocus={this.props.handleSelectCol}
                order={this.props.order}
                fixedField={this.props.lockColumn}
                selectedRows={this.props.selectedRows}
                fixedCellWidth={global.TABLE_FIXED_CELL_WIDTH +
                    (this.props.lockColumn ? this.props.lockColumn.width : 0) +
                    (this.props.statistics ? global.TABLE_STATUS_WIDTH : 0)}
                renderCell={this.renderCell}
                renderHeaderCell={this.renderHeaderCell}
                getValue={this.getValue}
                editableHeader={this.props.permissions.Designer && !this.props.mobile}
                innerComponent={!this.props.documents.length && !this.props.isLoading &&
                    <Empty count={this.props.count} mobile={this.props.mobile} />}
                onRowClick={this.props.mobile && this.props.onRowClick}
                onIconClick={!this.props.mobile && this.props.onIconClick}
                heightRow={global.TABLE_ROW_HEIGHT}
                renderFixedCell={!!this.props.statistics && this.renderFixedCell}
            />
        )
    }
}

const mapStateToProps = ({collection, entities, login}) => ({
	isLoading: collection.isLoading,
	count: collection.count,
    totals: collection.totals,
    createdRow: collection.createdRow,
    createdCol: entities.createdCol,
    statistics: collection.feedback,
    documents: collection.documents,
    permissions: login.permissions
})

export default connect(mapStateToProps, {
    fetchResizeColumn,
    fetchReorderColumns,
    fetchRenameCol,
    fetchDocumentUpdate,
    resetCreatedRow,
    resetCreatedCol,
    selectionChange
})(Spreadsheet)
